export const getBiasharaFlexiState = state => state?.biasharaFlexi;
